import { componentsSlice } from './ComponentsSlice';

const { actions } = componentsSlice;

export const selectPlant =
  (plantCode: string, plantSupportsCarrierConfiguration: boolean) =>
    (dispatch: (args: { payload: any; type: string }) => void) => {
      dispatch(
        actions.plantSelected({ plantCode, plantSupportsCarrierConfiguration })
      );
    };
